import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import RadioGroup from '@material-ui/core/RadioGroup';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import Excel from 'exceljs';
import {
  openTicketsState,
  closedTicketsState,
  userPreferencesState,
  allTicketsState,
  currentViewNameState,
} from '../TicketListSlice';
import useStyles from './styles';

const FileSaver = require('file-saver');

export default function ExcelExportPopUp(props) {
  const { openExportPopUp } = props;
  const [openCloseSelectionError, setOpenCloseSelectionError] =
    React.useState(false);
  const [noColsSelectedError, setNoColsSelectedError] = React.useState(false);

  const initialColumnSetting = {
    ticketId: true,
    wagonNumber: true,
    ticketCreator: true,
    type: true,
    ticketStatus: true,
    businessUnit: true,
    lastAnomaly: true,
    wagonStatus: true,
    loadedStatus: true,
    priority: true,
    damageCode: true,
    damagePlace: true,
    nextRevision: true,
    siteConcerned: true,
    keeper: true,
    productType: true,
    origin: true,
    labelWagon: true,
    appliedLabel: true,
    assignedWorkshop: true,
    openOrClosed: true,
  };
  const [selectTicketColumns, setSelectTicketColumns] =
    React.useState(initialColumnSetting);

  const initialPrefs = {
    prefrence: '1',
  };
  const [selectedPrefrence, setSelectedPrefrence] =
    React.useState(initialPrefs);

  const initialOpenClosePrefs = {
    openTickets: true,
    closedTickets: true,
  };
  const [openClosePrefs, setOpenClosePrefs] = React.useState(
    initialOpenClosePrefs,
  );

  const [all, setAll] = React.useState({ allSelected: true });

  React.useEffect(() => {
    if (openExportPopUp) {
      setSelectTicketColumns(initialColumnSetting);
      setSelectedPrefrence(initialPrefs);
      setOpenClosePrefs(initialOpenClosePrefs);
    }
  }, [openExportPopUp]);

  const openTickets = useSelector(openTicketsState);
  const closedTickets = useSelector(closedTicketsState);
  const [filteredTickets, setFilteredTickets] = React.useState([]);

  const [loading, setLoading] = React.useState(false);
  const classes = useStyles();
  const { t } = useTranslation();
  const allTickets = useSelector(allTicketsState);
  const userPreferences = useSelector(userPreferencesState);
  const currentViewName = useSelector(currentViewNameState);

  function findFilteredRows() {
    let result = allTickets;
    const { rowsFilters, ticketListFiltered } = userPreferences.find(
      (userPreference) => userPreference.viewName === currentViewName,
    );
    if (ticketListFiltered === 'closedTicketList') {
      result = closedTickets;
    } else if (ticketListFiltered === 'openTicketList') {
      result = openTickets;
    } else {
      result = allTickets;
    }

    rowsFilters.map((item) => {
      if (item.selectedOptions.length > 0) {
        result = result.filter(
          (row) => item.selectedOptions.includes(t(row[item.cell])) === true,
        );
      }
      return true;
    });
    setFilteredTickets(result);
  }

  const handleClose = () => {
    props.setExcelPopUpOpenedState(false);
  };
  const handlePrefrence = (event) => {
    const temp = { ...selectedPrefrence };
    temp.prefrence = event.target.value;
    findFilteredRows();
    setSelectedPrefrence(temp);
    setOpenCloseSelectionError(false);
  };

  const handleOpenClosePrefs = (event) => {
    const temp = { ...openClosePrefs };
    temp[event.target.name] = event.target.checked;

    setOpenClosePrefs(temp);
    if (event.target.checked === true) {
      setOpenCloseSelectionError(false);
    }
  };

  const updateSelectAll = (newSelections) => {
    const isAllSelected = Object.values(newSelections).every(
      (val) => val === true,
    );
    const tempAllSelected = { ...all };
    if (isAllSelected === true) {
      tempAllSelected.allSelected = true;
    } else {
      tempAllSelected.allSelected = false;
    }

    setAll(tempAllSelected);
  };

  const handleChange = (e) => {
    const temp = { ...selectTicketColumns };

    if (e.target.checked) {
      temp[e.target.name] = true;
      setNoColsSelectedError(false);
    } else {
      temp[e.target.name] = false;
      const tempAllSelected = { ...all };
      tempAllSelected.allSelected = false;
      setAll(tempAllSelected);
    }
    setSelectTicketColumns(temp);
    updateSelectAll(temp);
  };

  const handleSelectAll = (event) => {
    const temp = { ...selectTicketColumns };

    if (event.target.checked) {
      temp.ticketId = true;
      temp.wagonNumber = true;
      temp.ticketCreator = true;
      temp.type = true;
      temp.ticketStatus = true;
      temp.businessUnit = true;
      temp.lastAnomaly = true;
      temp.wagonStatus = true;
      temp.loadedStatus = true;
      temp.priority = true;
      temp.damageCode = true;
      temp.damagePlace = true;
      temp.nextRevision = true;
      temp.siteConcerned = true;
      temp.keeper = true;
      temp.productType = true;
      temp.origin = true;
      temp.labelWagon = true;
      temp.appliedLabel = true;
      temp.assignedWorkshop = true;
      temp.openOrClosed = true;
      setNoColsSelectedError(false);
    } else {
      temp.ticketId = true;
      temp.wagonNumber = true;
      temp.ticketCreator = false;
      temp.type = false;
      temp.ticketStatus = true;
      temp.businessUnit = false;
      temp.lastAnomaly = false;
      temp.wagonStatus = false;
      temp.loadedStatus = false;
      temp.priority = false;
      temp.damageCode = false;
      temp.damagePlace = false;
      temp.nextRevision = false;
      temp.siteConcerned = false;
      temp.keeper = false;
      temp.productType = false;
      temp.origin = false;
      temp.labelWagon = false;
      temp.appliedLabel = false;
      temp.assignedWorkshop = false;
      temp.openOrClosed = false;
    }
    setSelectTicketColumns(temp);

    const tempAllSelected = { ...all };
    tempAllSelected.allSelected = event.target.checked;

    setAll(tempAllSelected);
  };

  function getExcelRowHeader(filteredColumns) {
    const headers = [];
    if (filteredColumns.ticketId) {
      headers.push({ header: 'Ticket ID', key: 'ticketId' });
    }
    if (filteredColumns.wagonNumber) {
      headers.push({ header: 'Wagon', key: 'wagonNumber' });
    }
    if (filteredColumns.ticketCreator) {
      headers.push({ header: 'Ticket creator', key: 'ticketCreator' });
    }
    if (filteredColumns.type) {
      headers.push({ header: 'Type', key: 'type' });
    }
    if (filteredColumns.ticketStatus) {
      headers.push({ header: 'Ticket status', key: 'ticketStatus' });
    }
    if (filteredColumns.businessUnit) {
      headers.push({ header: 'Business unit', key: 'businessUnit' });
    }
    if (filteredColumns.lastAnomaly) {
      headers.push({ header: 'Last anomaly', key: 'lastAnomaly' });
    }
    if (filteredColumns.wagonStatus) {
      headers.push({ header: 'Wagon status', key: 'wagonStatus' });
    }
    if (filteredColumns.loadedStatus) {
      headers.push({ header: 'Loaded status', key: 'loadedStatus' });
    }
    if (filteredColumns.priority) {
      headers.push({ header: 'Priority', key: 'priority' });
    }
    if (filteredColumns.damageCode) {
      headers.push({ header: 'Damage codes', key: 'damageCode' });
    }
    if (filteredColumns.damagePlace) {
      headers.push({ header: 'Damage place', key: 'damagePlace' });
    }
    if (filteredColumns.nextRevision) {
      headers.push({ header: 'Next revision', key: 'nextRevision' });
    }
    if (filteredColumns.siteConcerned) {
      headers.push({ header: 'Site concerned', key: 'siteConcerned' });
    }
    if (filteredColumns.keeper) {
      headers.push({ header: 'Keeper', key: 'keeper' });
    }
    if (filteredColumns.productType) {
      headers.push({ header: 'Product type', key: 'productType' });
    }
    if (filteredColumns.origin) {
      headers.push({ header: 'Origin', key: 'origin' });
    }
    if (filteredColumns.labelWagon) {
      headers.push({ header: 'Label wagon', key: 'labelWagon' });
    }
    if (filteredColumns.appliedLabel) {
      headers.push({ header: 'Applied label', key: 'appliedLabel' });
    }
    if (filteredColumns.assignedWorkshop) {
      headers.push({ header: 'Assigned workshop', key: 'assignedWorkshop' });
    }
    if (filteredColumns.openOrClosed) {
      headers.push({ header: 'Open Or Closed', key: 'openOrClosed' });
    }
    return headers;
  }
  function getExcelRow(ticket, openOrClosedTicket, columnToFilter) {
    const row = {};
    if (columnToFilter.ticketId) {
      row.ticketId = ticket.ticketNumber;
    }
    if (columnToFilter.wagonNumber) {
      row.wagonNumber = ticket.wagonNumber;
    }
    if (columnToFilter.ticketCreator) {
      row.ticketCreator = ticket.ticketCreator;
    }
    if (columnToFilter.type) {
      row.type = ticket.plannedType;
    }
    if (columnToFilter.ticketStatus) {
      row.ticketStatus = ticket.ticketStatus;
    }
    if (columnToFilter.businessUnit) {
      row.businessUnit = ticket.businessUnit;
    }
    if (columnToFilter.lastAnomaly) {
      row.lastAnomaly = ticket.lastAnomalyDate;
    }
    if (columnToFilter.wagonStatus) {
      row.wagonStatus = ticket.wagonStatus;
    }
    if (columnToFilter.loadedStatus) {
      row.loadedStatus = ticket.loadedStatus;
    }
    if (columnToFilter.priority) {
      row.priority = ticket.priority;
    }
    if (columnToFilter.damageCode) {
      row.damageCode = ticket.damageCodes;
    }
    if (columnToFilter.damagePlace) {
      row.damagePlace = ticket.damagePlace;
    }
    if (columnToFilter.nextRevision) {
      row.nextRevision = ticket.nextRevisionDate;
    }
    if (columnToFilter.siteConcerned) {
      row.siteConcerned = ticket.siteConcerned;
    }
    if (columnToFilter.keeper) {
      row.keeper = ticket.keeper;
    }
    if (columnToFilter.productType) {
      row.productType = ticket.productType;
    }
    if (columnToFilter.origin) {
      row.origin = ticket.origin;
    }
    if (columnToFilter.labelWagon) {
      row.labelWagon = ticket.labelWagon;
    }
    if (columnToFilter.appliedLabel) {
      row.appliedLabel = ticket.appliedLabel;
    }
    if (columnToFilter.assignedWorkshop) {
      row.assignedWorkshop = ticket.assignedWorkshop;
    }
    if (columnToFilter.openOrClosed) {
      row.openOrClosed = openOrClosedTicket;
    }
    return row;
  }
  function download() {
    setLoading(true);
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('Maintenance Ticket list');

    if (selectedPrefrence.prefrence === '1') {
      if (
        openClosePrefs.openTickets === false &&
        openClosePrefs.closedTickets === false
      ) {
        setOpenCloseSelectionError(true);
        setLoading(false);
        return;
      }
      setOpenCloseSelectionError(false);

      worksheet.columns = getExcelRowHeader(selectTicketColumns);

      const isAllSelected = Object.values(selectTicketColumns).some(
        (val) => val === true,
      );
      if (!isAllSelected) {
        setNoColsSelectedError(true);
        setLoading(false);
        return;
      }
      setNoColsSelectedError(false);

      if (openClosePrefs.openTickets === true) {
        openTickets.forEach((ticket) => {
          worksheet.addRow(getExcelRow(ticket, 'OPEN', selectTicketColumns));
        });
      }
      if (openClosePrefs.closedTickets === true) {
        closedTickets.forEach((ticket) => {
          worksheet.addRow(getExcelRow(ticket, 'CLOSED', selectTicketColumns));
        });
      }
    } else {
      const { filteredColumns } = userPreferences.find(
        (userPreference) => userPreference.viewName === currentViewName,
      );
      const destructuredColumns = {};

      destructuredColumns.ticketId = true;
      destructuredColumns.wagonNumber = true;
      destructuredColumns.ticketCreator = filteredColumns.ticketCreator;
      destructuredColumns.type = filteredColumns.plannedType;
      destructuredColumns.ticketStatus = true;
      destructuredColumns.businessUnit = filteredColumns.businessUnit;
      destructuredColumns.lastAnomaly = filteredColumns.lastAnomalyDate;
      destructuredColumns.wagonStatus = filteredColumns.wagonStatus;
      destructuredColumns.loadedStatus = filteredColumns.loadedStatus;
      destructuredColumns.priority = filteredColumns.priority;
      destructuredColumns.damageCode = filteredColumns.damageCodes;
      destructuredColumns.damagePlace = filteredColumns.damagePlace;
      destructuredColumns.nextRevision = filteredColumns.nextRevisionDate;
      destructuredColumns.siteConcerned = filteredColumns.siteConcerned;
      destructuredColumns.keeper = filteredColumns.keeper;
      destructuredColumns.productType = filteredColumns.productType;
      destructuredColumns.origin = filteredColumns.origin;
      destructuredColumns.labelWagon = filteredColumns.labelWagon;
      destructuredColumns.appliedLabel = filteredColumns.appliedLabel;
      destructuredColumns.assignedWorkshop = filteredColumns.assignedWorkshop;

      worksheet.columns = getExcelRowHeader(destructuredColumns);

      filteredTickets.forEach((ticket) => {
        worksheet.addRow(
          getExcelRow(
            ticket,
            ticket.ticketStatus === 'CLOSED' ? 'CLOSED' : 'OPEN',
            destructuredColumns,
          ),
        );
      });
    }

    workbook.xlsx
      .writeBuffer()
      .then((buffer) =>
        FileSaver.saveAs(new Blob([buffer]), 'Maintenance Ticket List.xlsx'),
      )
      .catch((err) => console.log('Error writing excel export', err));

    setLoading(false);
  }
  return (
    <Dialog open={openExportPopUp} onClose={handleClose}>
      {loading && (
        <Paper elevation={0} position="absolute" zindex="2">
          <CircularProgress className={classes.loader} />
        </Paper>
      )}
      <DialogContent className={classes.dialog}>
        <Box>
          <Button color="secondary" variant="contained" onClick={download}>
            {t('export excel')}
          </Button>
        </Box>
        <Box mt={1}>
          <Divider />
        </Box>
        <FormGroup>
          <RadioGroup
            row
            aria-label="typeOfSelection"
            value={selectedPrefrence.prefrence}
            name="row-radio-buttons-grou1p"
          >
            <Grid container spacing={0}>
              <Grid item xs={6}>
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      onChange={handlePrefrence}
                      value="1"
                      name="radio-buttons"
                      inputProps={{ 'aria-label': 'All Tickets' }}
                    />
                  }
                  label={
                    <Typography className={classes.label}>
                      {t('All Tickets')}
                    </Typography>
                  }
                />
                <Box>
                  {openCloseSelectionError && (
                    <FormLabel className={classes.error}>
                      {t('Atleast select Opened or Closed Tickets.')}
                    </FormLabel>
                  )}
                </Box>
                <Box ml={5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={selectedPrefrence.prefrence !== '1'}
                        name="openTickets"
                        checked={openClosePrefs.openTickets === true}
                        onChange={handleOpenClosePrefs}
                      />
                    }
                    label={
                      <Typography className={classes.label}>
                        {t('Opened Tickets')}
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={selectedPrefrence.prefrence !== '1'}
                        name="closedTickets"
                        checked={openClosePrefs.closedTickets === true}
                        onChange={handleOpenClosePrefs}
                      />
                    }
                    label={
                      <Typography className={classes.label}>
                        {t('Closed Tickets')}
                      </Typography>
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={1}>
                {' '}
              </Grid>
              <Grid item xs={5}>
                <FormControlLabel
                  value="currentView"
                  control={
                    <Radio
                      onChange={handlePrefrence}
                      value="2"
                      name="radio-buttons"
                      inputProps={{ 'aria-label': 'Current View' }}
                    />
                  }
                  label={
                    <Typography className={classes.label}>
                      {t('Current View')}
                    </Typography>
                  }
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </FormGroup>
        <Divider />
        <FormLabel className={classes.label} mr={5}>
          {t('Select columns to export')}{' '}
        </FormLabel>
        <FormControlLabel
          control={
            <Checkbox
              disabled={selectedPrefrence.prefrence !== '1'}
              name="selectAll"
              checked={all.allSelected === true}
              onChange={handleSelectAll}
            />
          }
          label={
            <Typography className={classes.label} pl={5}>
              {t('Select All')}
            </Typography>
          }
        />
        <Box>
          {noColsSelectedError && (
            <FormLabel className={classes.error}>
              {t('Atleast select single column.')}
            </FormLabel>
          )}
        </Box>
        <Grid container spacing={0}>
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.ticketCreator === true}
                  onChange={handleChange}
                  name="ticketCreator"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Ticket creator')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.type === true}
                  onChange={handleChange}
                  name="type"
                />
              }
              label={
                <Typography className={classes.label}> {t('Type')}</Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.businessUnit === true}
                  onChange={handleChange}
                  name="businessUnit"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Business unit')}
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.lastAnomaly === true}
                  onChange={handleChange}
                  name="lastAnomaly"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Last anomaly')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.wagonStatus === true}
                  onChange={handleChange}
                  name="wagonStatus"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Wagon status')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.loadedStatus === true}
                  onChange={handleChange}
                  name="loadedStatus"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Loaded status')}
                </Typography>
              }
            />
          </Grid>
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.priority === true}
                  onChange={handleChange}
                  name="priority"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Priority')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.damageCode === true}
                  onChange={handleChange}
                  name="damageCode"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Damage codes')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.damagePlace === true}
                  onChange={handleChange}
                  name="damagePlace"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Damage place')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.siteConcerned === true}
                  onChange={handleChange}
                  name="siteConcerned"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Site concerned')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.keeper === true}
                  onChange={handleChange}
                  name="keeper"
                />
              }
              label={
                <Typography className={classes.label}>
                  {' '}
                  {t('Keeper')}
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.productType === true}
                  onChange={handleChange}
                  name="productType"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Product type')}
                </Typography>
              }
            />
          </Grid>

          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.origin === true}
                  onChange={handleChange}
                  name="origin"
                />
              }
              label={
                <Typography className={classes.label}>{t('Origin')}</Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.labelWagon === true}
                  onChange={handleChange}
                  name="labelWagon"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Label wagon')}
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.appliedLabel === true}
                  onChange={handleChange}
                  name="appliedLabel"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Applied label')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.nextRevision === true}
                  onChange={handleChange}
                  name="nextRevision"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Next revision')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.assignedWorkshop === true}
                  onChange={handleChange}
                  name="assignedWorkshop"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Assigned workshop')}
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={selectedPrefrence.prefrence !== '1'}
                  checked={selectTicketColumns.openOrClosed === true}
                  onChange={handleChange}
                  name="openOrClosed"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Open or Closed')}
                </Typography>
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
